import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../utils/SEO";

export default function CompanyFormationGibraltar() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.company-formation-gibraltar.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/company-formation-gibraltar"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/company-formation/mwali-hero-image.png')}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection title={tp('why1.title')} blocks={[{ items: obj('why1.items') }]} />

                    <WhySection title={tp('types.title')} blocks={[{ items: obj('types.items') }]} />

                    <WhySection title={tp('features.title')} blocks={[{ items: obj('features.items') }]} />

                    <InfoBlocks title={tp('process.title')} blocks={[{ items: obj('process.items') }]} />

                    <WhySection title={tp('uses.title')} blocks={[{ items: obj('uses.items') }]} />

                    <WhySection title={tp('whyUs.title')} blocks={[{ items: obj('whyUs.items') }]} />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')} />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};
